import {
  IconActionHistory,
  IconAgreements,
  IconDashboard,
  IconEmail,
  IconExpand,
  IconHelp,
  IconPeople,
  IconProducts,
  IconSetting,
  IconStatistics,
  IconStores,
  IconUserManagement,
} from "assets/icons";
import { UserRoleName } from "models";
import { NavMenuProps } from "./side-menu.types";

const SUPER_ADMIN_ONLY = [UserRoleName.SUPER_ADMIN];

export const navMenu: NavMenuProps[] = [
  {
    icon: IconDashboard,
    label: "Dashboard",
    navPath: "/dashboard",
    allowedRoles: SUPER_ADMIN_ONLY,
  },
  {
    icon: IconPeople,
    label: "Customers",
    navPath: "/customers",
    allowedRoles: SUPER_ADMIN_ONLY,
  },
  {
    icon: IconStores,
    label: "Stores",
    navPath: "/stores",
  },
  {
    icon: IconUserManagement,
    label: "User management",
    navPath: "/user-management",
    allowedRoles: SUPER_ADMIN_ONLY,
  },
  {
    icon: IconProducts,
    label: "Products",
    navPath: "/products",
  },
  {
    icon: IconExpand,
    label: "Departments",
    navPath: "/departments",
    allowedRoles: SUPER_ADMIN_ONLY,
  },
  {
    icon: IconStatistics,
    label: "Statistics",
    navPath: "/statistics",
  },
  {
    icon: IconActionHistory,
    label: "Action history",
    navPath: "/actionhistory",
  },
  {
    icon: IconAgreements,
    label: "Legal pages",
    navPath: "/legal",
    allowedRoles: SUPER_ADMIN_ONLY,
  },
  {
    icon: IconSetting,
    label: "Settings",
    navPath: "/settings",
  },
  {
    icon: IconHelp,
    label: "Help",
    navPath: "/help",
  },
  {
    icon: IconEmail,
    label: "Allowed-Email List",
    navPath: "/allowed-email",
    allowedRoles: SUPER_ADMIN_ONLY,
  },
];
